import resources from '~/modules/resources/types';
import {promiseAction} from '~/misc/dispatch';
import {prefetch} from '~/misc/brokers';

export default {
  [resources.RESOURCE_REQUESTED]: [
    (action, {dispatch, getState}) => {
      if (action.payload.name !== 'brokers-search-data') {
        return;
      }

      promiseAction(
        dispatch,
        getState,
        resources.RESOURCE,
        prefetch(),
        action.payload
      );
    },
  ],
};



// WEBPACK FOOTER //
// ./src/modules/brokers/reactions.js